import { imprint } from './company';
import { terms } from './terms';
import { privacy } from './privacy';
import { withdrawal } from './withdrawal';

export const legalDocuments = { imprint, terms, privacy, withdrawal };